import { render, staticRenderFns } from "./RoomCardRule.vue?vue&type=template&id=8bddc09e&scoped=true&"
import script from "./RoomCardRule.vue?vue&type=script&lang=js&"
export * from "./RoomCardRule.vue?vue&type=script&lang=js&"
import style0 from "./RoomCardRule.vue?vue&type=style&index=0&id=8bddc09e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bddc09e",
  null
  
)

export default component.exports